<template>
  <div class="the-team-container">
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <div
      class="container main-content"
      :style="{ backgroundImage: originBackground }"
    >
      <h1 class="title">{{ $t(`theTeam.title`) }}</h1>
      <div class="row">
        <div class="col-md-6">
          <img :src="isabelleAvatar" />
          <div class="name name-pink">ISABELLE</div>
          <div class="function">{{ $t(`theTeam.isabelle.position`) }}</div>
          <p class="text">
            {{ $t(`theTeam.isabelle.paragraphs[0]`) }}
          </p>
          <p class="text">
            {{ $t(`theTeam.isabelle.paragraphs[1]`) }}
          </p>
        </div>
        <div class="col-md-6">
          <img :src="herveAvatar" />
          <div class="name name-blue">HERVÉ</div>
          <div class="function">{{ $t(`theTeam.herve.position`) }}</div>
          <p>
            {{ $t(`theTeam.herve.paragraphs[0]`) }}
          </p>
          <p class="text">
            {{ $t(`theTeam.herve.paragraphs[1]`) }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <img :src="kaylaAvatar" />
          <div class="name name-pink">KAYLA</div>
          <div class="function">{{ $t(`theTeam.kayla.position`) }}</div>
          <p class="text">
            {{ $t(`theTeam.kayla.paragraphs[0]`) }}
          </p>
          <p class="text">
            {{ $t(`theTeam.kayla.paragraphs[1]`) }}
          </p>
        </div>
        <div class="col-md-4">
          <img :src="developersLogo" />
          <div class="function">{{ $t(`theTeam.developers.position`) }}</div>
          <p class="text">
            {{ $t(`theTeam.developers.paragraphs[0]`) }}
          </p>
        </div>
        <div class="col-md-4">
          <img :src="bodzAvatar" />
          <div class="name name-blue">BOD’Z</div>
          <div class="function">{{ $t(`theTeam.bodz.position`) }}</div>
          <p class="text">
            {{ $t(`theTeam.bodz.paragraphs[0]`) }}
          </p>
          <p class="text">
            {{ $t(`theTeam.bodz.paragraphs[1]`) }}
          </p>
        </div>
      </div>
    </div>
    <section
      class="bottom-section"
      :style="{ backgroundImage: bottomBackground }"
    >
      <h3 class="section-title">
        {{ $t(`theTeam.bottomSection.title`) }}
      </h3>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 content">
            <h4 class="section-subtitle">
              {{ $t(`theTeam.bottomSection.leftSection.title`) }}
            </h4>
            <p>
              {{ $t(`theTeam.bottomSection.leftSection.content`) }}
            </p>
          </div>
          <div class="col-md-5 content">
            <h4 class="section-subtitle">
              {{ $t(`theTeam.bottomSection.rightSection.title`) }}
            </h4>
            <p>
              {{ $t(`theTeam.bottomSection.rightSection.content`) }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FormePlaneteIizenglishRose from "@/assets/homepage/forme-planete-iizenglish-rose.webp";
import PatternIizenglishHomeAvantages from "@/assets/homepage/pattern-iizenglish-home-avantages.webp";
import Isabelle from "@/assets/theTeam/isabelle.webp";
import Herve from "@/assets/theTeam/herve.webp";
import Kayla from "@/assets/theTeam/kayla.webp";
import Bodz from "@/assets/theTeam/bodz.webp";
import Developers from "@/assets/theTeam/developers.webp";
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";

export default {
  name: "TheTeam",
  components: {
    StaticPagesHeader,
  },
  data() {
    return {
      originBackground: `url(${FormePlaneteIizenglishRose})`,
      bottomBackground: `url(${PatternIizenglishHomeAvantages})`,
      isabelleAvatar: Isabelle,
      herveAvatar: Herve,
      kaylaAvatar: Kayla,
      bodzAvatar: Bodz,
      developersLogo: Developers,
    };
  },
};
</script>

<style scoped lang="scss">
.the-team-container {
  .title {
    text-align: center;
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 3em;
    color: $primaryColor;
    margin: 40px 0 40px 0px;
  }

  .main-content {
    text-align: center;
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 39% auto;
    background-color: $whiteColor;
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);

    .name {
      font-size: 1.5em;
      font-family: "Averia Sans Libre", sans-serif;
    }

    .name-blue {
      color: $primaryColor;
    }

    .name-pink {
      color: $secondaryColor;
    }

    .function {
      font-weight: bold;
      padding-top: 1em;
      padding-bottom: 1em;
    }

    .text {
      padding-bottom: 0.8em;
    }
  }

  .bottom-section {
    background-color: $primaryColorLight;
    box-shadow: inset 0 0 0 1000px rgba(185, 206, 234, 0.8);
    background-position: bottom left;
    background-size: cover;
    padding: 50px 0px 50px 0px;
    width: 100%;
    align-items: center;

    .section-title {
      text-align: center;
      font-family: "Averia Sans Libre", sans-serif;
      font-size: 2em;
      color: $primaryColor;
      padding-bottom: 1em;
    }

    .content {
      background-color: $whiteColor;
      border-radius: 3em 3em 3em 3em;
      padding: 3em 2em 3em 2em;
      margin: 10px auto 10px auto;
      text-align: center;

      .section-subtitle {
        font-family: "Averia Sans Libre", sans-serif;
        font-size: 1.8em;
        color: $primaryColor;
        padding-bottom: 1em;
      }
    }
  }
}
</style>
